import withStyles from '@material-ui/styles/withStyles';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

export default withStyles({
  root: { padding: 0 },
})(MuiAccordionDetails);
